import type { ReactNode } from 'react';

export const symbol_desktop_landscape: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M270-320h300q12.75 0 21.38-8.63Q600-337.25 600-350v-140q0-12.75-8.62-21.38Q582.75-520 570-520H270q-12.75 0-21.37 8.62Q240-502.75 240-490v140q0 12.75 8.63 21.37Q257.25-320 270-320Zm96-286q6 6 14 6h280q8 0 14 6t6 14v100q0 8 6 14t14 6q8 0 14-6t6-14v-100q0-24.75-17.62-42.38Q684.75-640 660-640H380q-8 0-14 6t-6 14q0 8 6 14ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
